// import {loginModel} from './login.model';

export const models = angular.module('models', []);



/** WEBPACK FOOTER **
 ** ./src/app/models/models.js
 **/